<header>
  <h1>Urban population versus GDP per capita in Americas (2020)</h1>
</header>

<style>
  header {
    margin-top: 40px;
    margin-bottom: 30px;
    max-width: 600px;
  }

  h1 {
    font-family: "Merriweather";
    font-size: 22px;
    line-height: 30px;
    text-align: center;
  }
</style>
